module.exports = __webpack_public_path__ + "static/media/v12.96a6ae38.JPG";